import { useRef } from "react";
import { Image, Spinner } from "react-bootstrap";
import { ReactComponent as EditIcon } from '../svgs/photo.svg'

const imageTypes = "image/png, image/gif, image/jpeg"

const ProfileImage = ({
  size=30, 
  name = "Sample", 
  bgcolor="red", 
  src="",
  onChanged=(file:File)=>{},
  editable=false,
  loading=false,
  radius="50%",
  outline="solid"
}) => {
  const ref = useRef<HTMLInputElement>(null)
  //const [imgSrc,setImgSrc] = useState(src)

  if (name === "") return  <></>
  const nameParts = name[0] + name[1]
  const _onClick = () => {
    if (editable)
      ref.current!.click()
  }
  const onImageChanged = (e:any) => {
    const filelist = e.target.files
    if (!filelist || filelist.length === 0) return

    const imgBlob : File = filelist[0]
    onChanged(imgBlob)
    // const creator = window.URL || window.webkitURL
    // const src = creator.createObjectURL(imgBlob)
    // setImgSrc(src)
  }
  return (
    <>
    {editable && <input ref={ref} style={{display:"none"}} type="file" accept={imageTypes} onChange={onImageChanged}/>}
    {src === "" &&  <span style={{
        display:"flex",
        justifyContent: "center",
        alignItems: "center",
        width: size,
        height: size,
        backgroundColor: bgcolor,
        color: "black",
        fontSize: size * 0.4,
        borderRadius: radius,
        fontWeight: "500",
        cursor: "pointer"
    }} onClick={_onClick}>
        {nameParts.toUpperCase()}
    </span>}
    {src !== "" && <Image src={src} style={{
      width: size,
      height: size,
      borderRadius: radius,
      objectFit: "cover",
      outline: "auto",
      outlineStyle: outline,
      outlineColor: "#007cff"
    }} onClick={_onClick}/>}
    {editable && <div style={{position: "relative"}}>
      <EditIcon stroke="gray" style={{position:"absolute",bottom:"-5px",right:"-7px"}} onClick={_onClick}/>
      {loading && <Spinner 
        style={{position:"absolute",width:30, height:30, color:"#007cff", left:(size/2)-15, bottom: (size/2)-15}} 
        role="status"/>}
    </div>}
    
    </>
  );
};
export default ProfileImage;